import BreakBehindBreakoutModuleMid from './BreakBehindBreakoutModuleMid'

export default BreakBehindBreakoutModuleMid
